/**
 * テンプレート一覧テーブル
 *
 * CSVテンプレートの一覧表示コンポーネント
 */

import { Table, Badge, Text, Center, Loader, Paper } from "@mantine/core";
import { CsvTemplateCommon } from "../../services/csvSettingsService";
import { formatTimestamp } from "../../utils/formatters";

interface TemplateTableProps {
  templates: CsvTemplateCommon[];
  loading: boolean;
  onSelect: (template: CsvTemplateCommon) => void;
}

/**
 * テンプレート一覧テーブル
 */
export function TemplateTable({ templates, loading, onSelect }: TemplateTableProps) {
  if (loading) {
    return (
      <Paper shadow="xs" p="lg" radius="md" withBorder>
        <Center py="xl">
          <Loader />
        </Center>
      </Paper>
    );
  }

  if (templates.length === 0) {
    return (
      <Paper shadow="xs" p="lg" radius="md" withBorder>
        <Text c="dimmed" ta="center" py="xl">
          テンプレートがありません
        </Text>
      </Paper>
    );
  }

  return (
    <Paper shadow="xs" p="lg" radius="md" withBorder>
      <Table highlightOnHover>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>テンプレート名</Table.Th>
            <Table.Th>説明</Table.Th>
            <Table.Th>文字コード</Table.Th>
            <Table.Th>列数</Table.Th>
            <Table.Th>更新日</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {templates.map((tmpl) => (
            <Table.Tr key={tmpl.id} onClick={() => onSelect(tmpl)} style={{ cursor: "pointer" }}>
              <Table.Td fw={500}>{tmpl.name}</Table.Td>
              <Table.Td>{tmpl.description || "-"}</Table.Td>
              <Table.Td>
                <Badge variant="dot" color={tmpl.encoding === "shift_jis" ? "orange" : "blue"}>
                  {tmpl.encoding === "shift_jis" ? "Shift_JIS" : "UTF-8"}
                </Badge>
              </Table.Td>
              <Table.Td>{tmpl.columns.length}</Table.Td>
              <Table.Td>{formatTimestamp(tmpl.updatedAt)}</Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </Paper>
  );
}
